export const CHANGE_PASSWORD = 'APP/CHANGE_PASSWORD'
export const CHANGE_PASSWORD_SUCCESS = 'APP/CHANGE_PASSWORD_SUCCESS'
export const CHANGE_PASSWORD_ERROR = 'APP/CHANGE_PASSWORD_ERROR'
export const CHANGE_PASSWORD_CLEAN_UP = 'APP/CHANGE_PASSWORD/CLEAN_UP'
